'use strict';
var WellevateCalloutController = /** @class */ (function () {
    /*@ngInject*/
    function WellevateCalloutController(Auth, $scope) {
        var _this = this;
        this.loggedInUser = {};
        this.accountFinishedLoading = false;
        this.welcomeName = '';
        this.Auth = Auth;
        var self = this;
        this.Auth.subscribe($scope, function (event, user) {
            if (user) {
                self.loggedInUser = user;
                if (user.firstName) {
                    self.welcomeName = user.firstName;
                }
                else if (user.businessName) {
                    self.welcomeName = user.businessName;
                }
            }
            self.accountFinishedLoading = true;
        }, true);
        this.checkMergedAccountSub = this.Auth.checkIfSsoMergeIsPossible(true).subscribe(function (isMergedAccount) {
            _this.isMergedAccount = isMergedAccount;
        });
    }
    WellevateCalloutController.prototype.$onDestroy = function () {
        if (this.checkMergedAccountSub && !this.checkMergedAccountSub.closed) {
            this.checkMergedAccountSub.unsubscribe();
        }
    };
    return WellevateCalloutController;
}());
export default WellevateCalloutController;
//# sourceMappingURL=wellevate-callout.controller.js.map